import { render, staticRenderFns } from "./SeniorFileViewer.vue?vue&type=template&id=06974594&scoped=true&"
import script from "./SeniorFileViewer.vue?vue&type=script&lang=js&"
export * from "./SeniorFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./SeniorFileViewer.vue?vue&type=style&index=0&id=06974594&lang=scss&scoped=true&"
import style1 from "./SeniorFileViewer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06974594",
  null
  
)

export default component.exports